module.exports = __webpack_public_path__ + "static/media/arrow_up.8071a6ce.svg";